import EmployeeAssignmentDetails from "./employee-assignment-details";
import EmployeeAssignmentList from "./employee-assignment-list";

function EmployeeAssignment({ employeeId, subpage }) {
  if(subpage) {
    return <EmployeeAssignmentDetails employeeId={employeeId} subpage={subpage} />
  } else {
    //return (<div style={{ height: '100%', overflow: "auto"}}><AssignmentTable as={ActionTableState} preselectedEmployeeId={employeeId} /></div>)
    return <EmployeeAssignmentList employeeId={employeeId} />
  }
}

export default EmployeeAssignment;